import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { PRODUCT_INFO } from '@hsc/common/constants/product-info';
import { SampleContractModal } from '@components/sample-contract.modal';
import { COVERED_ITEMS } from '@constants/covered-items';
import { FullStoryEventDirective } from '@directives/fullstory-event.directive';
import { scrollToSection } from '@utilities/scroll-to-section';

@Component({
  selector: 'hsc-hero',
  imports: [CommonModule, SampleContractModal, FullStoryEventDirective],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <div class="bolt-container">
      <div class="flex flex-row gap-6 py-8">
        <div class="flex flex-[2] flex-shrink-0 flex-col items-center justify-center gap-0 py-6">
          <div class="flex flex-col items-center justify-center gap-2.5">
            <div class="flex flex-col items-center justify-center gap-1">
              <h2 class="text-vibrant-blue bolt-heading-lg bolt-serif text-center text-nowrap">
                <span class="flex">
                  <div class="bolt-heading-lg bolt-serif">Nationwide</div>
                  <div class="bolt-heading-sm !font-medium">&reg;</div>
                  <div class="bolt-heading-lg bolt-serif">&nbsp;{{ productInfo.name }}</div>
                </span>
              </h2>
            </div>
            <h2 class="text-charcoal bolt-heading-xs !mb-8 text-center">
              Protection for your home systems and appliances
            </h2>
          </div>
          <div class="flex items-start" [ngClass]="'w-full flex-row gap-x-8'">
            <div class="w-full max-w-none">
              <div class="mx-auto mt-8 w-[370px]">
                <div
                  class="bolt-container bg-secondary-container flex !h-[230px] w-full flex-col items-center justify-center p-6 text-center"
                  hscFsEventName="Cost Information Section Clicked"
                >
                  <div>
                    <p class="bolt-heading-xs !mt-2 !mb-0">Starting at</p>
                  </div>
                  <div>
                    <h1 class="bolt-heading-xl bolt-sans-serif">$85.00</h1>
                    <p class="bolt-body-md !mb-0">/mo + tax</p>
                  </div>
                  <div>
                    <p class="bolt-body-md !mb-2">+ $30 one-time enrollment fee</p>
                  </div>
                  <div>
                    <p class="bolt-body-md !mb-2">$150 service fee per claim</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-8 flex w-full flex-col items-center justify-center gap-6">
              <h2 class="bolt-heading-sm !m-0 !p-0">What's covered?</h2>
              <div class="bolt-container mt-6">
                <div class="grid grid-flow-col grid-rows-6 justify-center gap-x-8 lg:grid-rows-4 xl:grid-rows-3">
                  @for (item of coveredItems; track item) {
                    <div class="text-charcoal text-left text-nowrap">&bull; {{ item }}</div>
                  }
                </div>
              </div>
              <a
                class="bolt-body-md py-1"
                hscFsEventName="Coverage Limits Link Clicked"
                href="#coverage-limits"
                (click)="scrollToSection($event, 'coverage-limits')"
                >View coverage limits</a
              >
              <hsc-sample-contract-modal class="w-full items-center justify-center" />
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class Hero {
  readonly coveredItems = COVERED_ITEMS;
  readonly productInfo = PRODUCT_INFO;
  scrollToSection = scrollToSection;
}
